(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pauls-collection-ux"] && !Shopify.designMode) return;
  try {
    function initialisePaulsCollectionTools() {
    const tools = document.querySelector('[data-pauls-collection-tools]');
    const toolbar = document.querySelector('.product-grid-block .pg-toolbar');

    if (!tools || !toolbar || tools.dataset.initialised === 'true') return;

    toolbar.parentNode.insertBefore(tools, toolbar);
    tools.dataset.initialised = 'true';

    const filterLabel = toolbar.querySelector('[data-open-filters] span:first-child');
    const activeCount = Number(tools.dataset.activeFilterCount || 0);
    if (filterLabel && activeCount > 0) {
      filterLabel.textContent = `${filterLabel.textContent.trim()} (${activeCount})`;
    }

    document.querySelectorAll('[data-quick-filter-scroll]').forEach((viewport) => {
      const container = viewport.closest('.pauls-quick-filter-scroll');
      if (!container) return;

      const updateScrollHint = () => {
        const scrollable = viewport.scrollWidth > viewport.clientWidth + 2;
        const atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
        container.classList.toggle('is-scrollable', scrollable);
        container.classList.toggle('is-at-end', atEnd);
      };

      viewport.addEventListener('scroll', updateScrollHint, { passive: true });
      window.addEventListener('resize', updateScrollHint, { passive: true });
      updateScrollHint();
    });

    const sortSelect = toolbar.querySelector('select[name="sort_by"]');
    if (!sortSelect) return;

    const sortGroup = sortSelect.closest('.pg-toolbar__group--sort');
    if (sortGroup && !sortGroup.querySelector('.pauls-sort-label')) {
      const sortLabel = document.createElement('span');
      sortLabel.className = 'pauls-sort-label';
      sortLabel.textContent = tools.dataset.sortLabel || '';
      sortGroup.insertBefore(sortLabel, sortSelect);
    }

    const sortForm = sortSelect.form;
    if (sortForm) {
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.delete('page');
      currentParams.delete('sort_by');
      currentParams.forEach((value, name) => {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = name;
        hiddenInput.value = value;
        sortForm.appendChild(hiddenInput);
      });
    }

    const allowedValues = new Set([
      'manual',
      'best-selling',
      'price-ascending',
      'price-descending',
      'created-descending'
    ]);

    Array.from(sortSelect.options).forEach((option) => {
      if (!allowedValues.has(option.value) && !option.selected) option.remove();
    });

    if (document.documentElement.lang.toLowerCase().startsWith('de')) {
      const labels = {
        'manual': 'Empfohlen',
        'best-selling': 'Meistverkauft',
        'price-ascending': 'Preis: tiefster zuerst',
        'price-descending': 'Preis: höchster zuerst',
        'created-descending': 'Neueste zuerst'
      };

      Array.from(sortSelect.options).forEach((option) => {
        if (labels[option.value]) option.textContent = labels[option.value];
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialisePaulsCollectionTools, { once: true });
  } else {
    initialisePaulsCollectionTools();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pauls-performance"] && !Shopify.designMode) return;
  try {
    const paulsPrefetchedProducts = new Set();

  function prefetchPaulsProduct(link) {
    if (!link || paulsPrefetchedProducts.size >= 6) return;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/products/')) return;
    if (paulsPrefetchedProducts.has(url.href)) return;

    paulsPrefetchedProducts.add(url.href);
    const hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.href = url.href;
    hint.as = 'document';
    document.head.appendChild(hint);
  }

  document.addEventListener('pointerover', (event) => {
    prefetchPaulsProduct(event.target.closest('a[href*="/products/"]'));
  }, { passive: true });

  document.addEventListener('focusin', (event) => {
    prefetchPaulsProduct(event.target.closest('a[href*="/products/"]'));
  });

  document.addEventListener('pointerdown', (event) => {
    prefetchPaulsProduct(event.target.closest('a[href*="/products/"]'));
  }, { passive: true });

  window.addEventListener('pageshow', () => {
    document.getElementById('page-transition-overlay')?.classList.remove('page-transition--visible');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pauls-product-ux"] && !Shopify.designMode) return;
  try {
    function initialisePaulsMobilePurchase() {
    const stickyButton = document.querySelector('[data-pauls-mobile-add]');
    if (!stickyButton || stickyButton.dataset.initialised === 'true') return;

    const nativeButton = document.querySelector('.simple-product .atc__form [data-add-btn]');
    const stickyPrice = document.querySelector('.pauls-mobile-purchase__price');
    const nativePrice = document.querySelector('.simple-product [data-price]');

    const syncPurchaseBar = () => {
      if (!nativeButton) return;
      stickyButton.disabled = nativeButton.disabled;
      const nativeLabel = nativeButton.querySelector('[data-add-btn-text]');
      if (nativeLabel) stickyButton.textContent = nativeLabel.textContent.trim();
      if (stickyPrice && nativePrice) stickyPrice.textContent = nativePrice.textContent.trim();
    };

    stickyButton.dataset.initialised = 'true';
    stickyButton.addEventListener('click', () => {
      if (!nativeButton || nativeButton.disabled) return;
      nativeButton.click();
    });

    if (nativeButton) {
      const observer = new MutationObserver(syncPurchaseBar);
      observer.observe(nativeButton, { attributes: true, childList: true, subtree: true });
    }
    if (nativePrice) {
      const priceObserver = new MutationObserver(syncPurchaseBar);
      priceObserver.observe(nativePrice, { childList: true, subtree: true });
    }
    syncPurchaseBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialisePaulsMobilePurchase, { once: true });
  } else {
    initialisePaulsMobilePurchase();
  }
  } catch(e) { console.error(e); }
})();

})();
